/**
 * searchDetailsAndFilterBlock_MainPage_INTERNAL_CONSTANTS.ts
 *
 * Internal Constants within SearchDetailsAndFilterBlock_MainPage_Root and other code it calls, like User Input Overlay
 */


export const SearchDetailsAndFilterBlock_MainPage_INTERNAL_CONSTANTS = {
    USER_CLICKED_IN_TYPE_PSM : "PSM",
    USER_CLICKED_IN_TYPE_PEPTIDE : "Peptide",
    USER_CLICKED_IN_TYPE_PROTEIN : "Protein",
    USER_CLICKED_IN_TYPE_MODIFICATION_POSITION : "Modification Position"
}

